import React, { useState } from 'react';

const defaultValue = {
  contasReceber: [],
  pendencias: [],
  visualizarPendencias: false,
  contaReceberAtual: {},
  contaReceberId: undefined,
  somatorios: {},
  selecao: [],
  tipoSelecao: 'NENHUM',
  filtroAvancado: {},
  loading: false,
  fabHidden: false,
  totalElements: 0,
  modal: '',
  search: '',
  page: 0,
  size: 15,
  sort: 'dataVencimento,DESC',
  existemBoletosPendentes: false, // Verificador para boletos pendentes de geração de remessa.
};

export const ContaReceberContext = React.createContext({});

export const ContaReceberProvider = (props) => {
  return (
    <ContaReceberContext.Provider
      value={{
        contasReceber: useState(defaultValue.contasReceber),
        pendencias: useState(defaultValue.pendencias),
        visualizarPendencias: useState(defaultValue.visualizarPendencias),
        contaReceberAtual: useState(defaultValue.contaReceberAtual),
        contaReceberId: useState(defaultValue.contaReceberId),
        somatorios: useState(defaultValue.somatorios),
        loading: useState(defaultValue.loading),
        selecao: useState(defaultValue.selecao),
        tipoSelecao: useState(defaultValue.tipoSelecao),
        filtroAvancado: useState(defaultValue.filtroAvancado),
        fabHidden: useState(defaultValue.fabHidden),
        totalElements: useState(defaultValue.totalElements),
        modal: useState(defaultValue.modal),
        search: useState(defaultValue.search),
        page: useState(defaultValue.page),
        size: useState(defaultValue.size),
        sort: useState(defaultValue.sort),
        existemBoletosPendentes: useState(defaultValue.existemBoletosPendentes),
      }}
    >
      {props.children}
    </ContaReceberContext.Provider>
  );
};

export const ContaReceberConsumer = ContaReceberContext.Consumer;
